import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Tag, Empty, Flex, Typography } from 'antd';
import { IconTable } from '@tabler/icons-react';
import { CsvPreviewTableProps } from '~/app/components/knowledgeBase/componentSchemaManager/ComponentSchemaManager.types';
import { previewHeaderStyle } from '~/app/components/knowledgeBase/componentSchemaManager/ComponentSchemaManager.style';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

const { Text } = Typography;

export const CsvPreviewTable = (props: CsvPreviewTableProps) => {
  const { t } = useTranslation('componentSchema');

  const { columns, data, errors, status } = props;

  if (status === 'idle') {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t('previewTable.emptyDescription')}
      />
    );
  }

  if (status === 'error' && errors.length > 0) {
    return (
      <Flex vertical gap={8}>
        {errors.map((err, i) => (
          <Alert key={i} message={err} type="error" showIcon />
        ))}
      </Flex>
    );
  }

  const tableColumns = columns.map((col) => ({
    title: (
      <Flex align="center" gap={4}>
        <Text strong style={{ fontSize: 13 }}>
          {col.title}
        </Text>
        {col.required && (
          <Tag
            color="red"
            style={{ fontSize: 10, lineHeight: '16px', margin: 0 }}
          >
            {t('previewTable.required')}
          </Tag>
        )}
      </Flex>
    ),
    dataIndex: col.key,
    key: col.key,
    ellipsis: true,
    render: (value: string) => (
      <Text style={{ fontSize: 13 }}>
        {value || <Text type="secondary">—</Text>}
      </Text>
    ),
  }));

  return (
    <Flex vertical>
      <Flex style={previewHeaderStyle}>
        <Flex align="center" gap={8}>
          <IconTable size={18} color="#1E6DF6" />
          <Text strong>{t('previewTable.dataPreview')}</Text>
          <Tag color="blue">
            {t('previewTable.rows', { count: data.length })}
          </Tag>
        </Flex>
      </Flex>

      <EvimoTable
        columns={tableColumns}
        dataSource={data.map((row, index) => ({ ...row, key: index }))}
        size="small"
        bordered
        pagination={{
          pageSize: 10,
        }}
        scroll={{ x: 'max-content' }}
        style={{ borderRadius: 8, overflow: 'hidden' }}
      />
    </Flex>
  );
};
